//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableComponentServerSingleWithFilter from '../../components/TableComponent/TableComponentServerSingleWithFilter.vue'
import RequestWorkTypeDoneIndicator from './RequestWorkTypeDoneIndicator.vue'
import RequestWorkTypeReportInclusionMode from './RequestWorkTypeReportInclusionMode.vue'
import RequestWorkTypeRequiredIcon from './RequestWorkTypeRequiredIcon.vue'
import RequestWorkTypeIncludedInWorkPackagesIndicator from './RequestWorkTypeIncludedInWorkPackagesIndicator.vue'
import RequestWorkTypeStatusCheckbox from './RequestWorkTypeStatusCheckbox.vue'
import RequestWorkTypesPickerPackagesWarning from './RequestWorkTypesPickerPackagesWarning.vue'

export default {
  name: 'RequestWorkTypesPicker',
  components: {
    TableComponentServerSingleWithFilter,
    RequestWorkTypeDoneIndicator,
    RequestWorkTypeReportInclusionMode,
    RequestWorkTypeRequiredIcon,
    RequestWorkTypeIncludedInWorkPackagesIndicator,
    RequestWorkTypeStatusCheckbox
  },
  props: {
    store: {
      type: Object,
      required: true
    },
    headerLabel: {
      type: String,
      default () {
        return 'Выбор работ/комплексов работ'
      }
    },
    selectedItems: {
      type: Array,
      default () {
        return []
      }
    },
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    workTypes: {
      type: Array,
      default: () => []
    },
    workPackages: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String, // 'workTypes' || 'workPackages' || 'autoAssignWorkTypes'
      default: null
    }
  },
  data: function () {
    return {
      columns: [
        {
          name: 'name',
          label: 'Наименование',
          field: 'name',
          align: 'left',
          searchable: true
        }
      ],
      selectedItemsLocal: JSON.parse(JSON.stringify(this.selectedItems)),
      selectedItemsIds: this.selectedItems.map(i => i.id),

      optionValue: 'id',
      optionLabel: 'name'
    }
  },
  computed: {

  },
  methods: {
    onItemSelected: function (item) {
      const itemIndex = this.selectedItemsIds.indexOf(item[this.optionValue])
      if (itemIndex === -1) {
        // Ищем среди старых значений
        const itemOld = this.selectedItems.find(itemOld => itemOld[this.optionValue] === item[this.optionValue])
        if (itemOld) {
          item = itemOld
        }
        this.selectedItemsIds.push(item[this.optionValue])
        this.selectedItemsLocal.push(item)
      } else {
        this.selectedItemsIds.splice(itemIndex, 1)
        this.selectedItemsLocal.splice(itemIndex, 1)
      }
      this.$emit('selected-items', this.selectedItemsLocal)
    },
    onClearSelection: function () {
      this.selectedItemsLocal = this.selectedItemsLocal.filter(wT => wT._disabled)
      this.selectedItemsIds = this.selectedItemsLocal.map(wT => wT.id)
    },
    onSelectAllItems: function () {
      if (!this.store.proxy || this.store.fullReadable) {
        this.selectedItemsLocal = JSON.parse(JSON.stringify(this.store._itemsFiltered))
        this.selectedItemsIds = JSON.parse(JSON.stringify(this.store._itemsFiltered.map(item => item[this.optionValue])))
      } else if (this.store && this.store.proxy && this.store.proxy.selectAll) {
        this.$q.loading.show({ spinnerColor: 'blue-11' })
        this.store.proxy.selectAll.itemsFn(this.store.proxy.searchValue, this.optionValue, this.optionLabel)
          .then(result => {
            this.selectedItemsLocal = result
            this.selectedItemsIds = result.map(item => item[this.optionValue])
          }).finally(() => {
            this.$q.loading.hide()
          })
      }
    },
    emitSelect: function () {
      this.selectedItemsLocal.forEach(sI => {
        delete sI._disabled
      })
      this.$emit('select', this.selectedItemsLocal)
    },
    onSaveSelection: function () {
      if (this.mode === 'workPackages') {
        const worksFromRequest = {}
        this.selectedItemsLocal.filter(sI => !this.workPackages.some(wP => wP.id === sI.id)).forEach(workPackage => {
          workPackage.workTypes.forEach(workType => {
            if (this.workTypes.some(wT => wT.id === workType.id) || this.workPackages.some(wP => wP.workTypes.some(wT => wT.id === workType.id))) {
              if (!worksFromRequest[workType.id]) {
                const workTypeDuplicate = {
                  id: workType.id,
                  name: workType.name,
                  workPackages: this.workPackages.filter(wP => wP.workTypes.some(wT => wT.id === workType.id)).map(wP => {
                    return {
                      id: wP.id,
                      name: wP.name
                    }
                  }),
                  standalone: this.workTypes.some(wT => wT.id === workType.id)
                }
                worksFromRequest[workType.id] = workTypeDuplicate
              }
            }
          })
        })
        if (Object.values(worksFromRequest).length) {
          const dialog = this.$d.dialog(this).show({
            contentComponent: RequestWorkTypesPickerPackagesWarning,
            contentProps: {
              worksFromRequest
            },
            contentWidth: 1000,
            headerLabel: 'Обнаружены дубликаты работ',
            componentHandlers: {
              ok: () => {
                this.emitSelect()
                dialog.hide()
              },
              cancel: () => {
                dialog.hide()
              }
            }
          })
        } else {
          this.emitSelect()
        }
      } else {
        this.emitSelect()
      }
    },
    getWorkPackagesFromRequest: function (workType) {
      return this.workPackages
        .filter(wP => wP.workTypes
          .map(wT => wT.id)
          .includes(workType.id))
        .map(wP => {
          return {
            name: wP.name,
            id: wP.id
          }
        })
    },
    onSelectInclusionMode: function (event) {
      const selectedItemLocal = this.selectedItemsLocal.find(wT => wT.id === event.id)
      const selectedItem = this.selectedItems.find(wT => wT.id === event.id)
      if (selectedItem) {
        this.$set(selectedItem, 'inclusionMode', event.inclusionMode)
      }
      if (selectedItemLocal) {
        this.$set(selectedItemLocal, 'inclusionMode', event.inclusionMode)
      } else {
        this.selectedItemsIds.push(event.id)
        this.selectedItemsLocal.push(event)
      }
    }
  }
}
